import React from 'react';
import STATS from '../../data/stats';
import SectionHeader from '../ui/SectionHeader';
import RACES from '../../data/races'

import { STAT_POINTS_TO_ALLOCATE } from '../../config/gameConfig';
// ─── STEP 1: STATS ──────────────────────────────────────────────────────────
function StatStep({ character, setCharacter, finalStats, statPointsUsed }) {
  const race = RACES.find(r => r.id === character.race);
  const remaining = STAT_POINTS_TO_ALLOCATE - statPointsUsed;

  function adjust(statId, delta) {
    const current = character.statPoints[statId] || 0;
    if (delta < 0 && current <= 0) return;
    if (delta > 0 && remaining <= 0) return;
    setCharacter({ ...character, statPoints: { ...character.statPoints, [statId]: current + delta } });
  }

  return (
    <div>
      <SectionHeader>Allocate Stat Points</SectionHeader>
      <p style={{ fontSize: "13px", color: "#8a7e5e", marginBottom: 20, lineHeight: 1.5 }}>
        Distribute <strong style={{ color: "#c9a84c" }}>10 points</strong> among your stats. Your race provides a base — these points are added on top.
        Might, Speed, and Intellect function as health pools. Magic is spent to cast spells.
      </p>
      <div style={{ display: "grid", gap: "12px" }}>
        {STATS.map(stat => {
          const base = race.stats[stat.id];
          const added = character.statPoints[stat.id] || 0;
          const total = finalStats[stat.id];
          const modifier = Math.floor(total / 10);
          return (
            <div key={stat.id} style={{ background: "rgba(20,16,10,0.6)", border: `1px solid ${stat.color}33`, borderRadius: "8px", padding: "14px 16px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: stat.color, boxShadow: `0 0 8px ${stat.color}55` }} />
                  <span style={{ fontFamily: "'Cinzel', serif", fontSize: "14px", color: stat.color }}>{stat.label}</span>
                  <span style={{ fontSize: "11px", color: "#6b6048" }}>— {stat.description}</span>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                {/* Controls */}
                <button onClick={() => adjust(stat.id, -1)} style={{ background: "none", border: "1px solid rgba(201,168,76,0.3)", color: "#c9a84c", width: 28, height: 28, borderRadius: 4, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                <div style={{ display: "flex", alignItems: "baseline", gap: 4, minWidth: 80 }}>
                  <span style={{ fontFamily: "'Cinzel', serif", fontSize: "24px", color: stat.color }}>{total}</span>
                  <span style={{ fontSize: "10px", color: "#6b6048" }}>({base} + {added})</span>
                </div>
                <button onClick={() => adjust(stat.id, 1)} style={{ background: "none", border: "1px solid rgba(201,168,76,0.3)", color: "#c9a84c", width: 28, height: 28, borderRadius: 4, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                {/* Progress bar */}
                <div style={{ flex: 1, minWidth: 100 }}>
                  <div style={{ height: 4, background: "rgba(201,168,76,0.1)", borderRadius: 2 }}>
                    <div style={{ height: "100%", width: `${Math.min((total / 50) * 100, 100)}%`, background: stat.color, borderRadius: 2, transition: "width 0.2s" }} />
                  </div>
                  <div style={{ fontSize: "9px", color: "#5a5040", marginTop: 2 }}>Max 50 | Modifier: +{modifier}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StatStep
